module.exports = __webpack_public_path__ + "img/3.8abd8a9c.jpg";